import { usd } from '../../lib/admin';

/* Admin dashboard: top users by cumulative cost. Presentational — the ranked */
/* entries + the id→email map come from the parent. Extracted from Admin.tsx */
/* (NAI-207). */
export function TopUsers({
  topUsers,
  userEmails,
}: {
  topUsers: [string, number][];
  userEmails: Map<string, string>;
}) {
  if (topUsers.length === 0) {
    return <p className="p-3 text-muted-foreground text-[13px]">Aucune donnée sur cette période.</p>;
  }
  return (
    <div className="border border-border rounded-[12px] overflow-hidden bg-card">
      {topUsers.map(([uid, cost]) => (
        <div key={uid} className="flex justify-between p-[6px_12px] border-b border-naia-line-soft font-mono text-[12px]">
          <span className="text-muted-foreground">{userEmails.get(uid) ?? uid}</span>
          <span className="font-extrabold">{usd(cost)}</span>
        </div>
      ))}
    </div>
  );
}
